module.exports = __webpack_public_path__ + "img/Group 11.f6ded2ca.jpg";